import { Skeleton } from '@/components/ui/skeleton';
import { Event } from '../../../graphql/generatedTypes';

import {
  EventInfoCard,
  EventInfoCardActions,
  EventInfoCardDate,
  EventInfoCardStatus,
  EventInfoCardTitle,
} from './EventInfoCard';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { ComponentProps } from 'react';

export function EventOwnerEventCards({
  events,
  isLoading,
  onEventSelect,
}: {
  events: Event[];
  isLoading?: boolean;
  onEventSelect?: (event: Event) => void;
}) {
  return (
    <div className="tw:container tw:flex tw:flex-col tw:gap-4">
      <h1 className="tw:text-2xl tw:font-semibold">Events</h1>
      <div className="tw:flex tw:flex-row tw:flex-wrap tw:gap-4 tw:justify-center tw:sm:justify-start">
        {isLoading && (
          <>
            <Skeleton className="tw:w-[327px] tw:h-[266px] tw:rounded-xl tw:shadow-sm" />
            <Skeleton className="tw:w-[327px] tw:h-[266px] tw:rounded-xl tw:shadow-sm" />
          </>
        )}
        {events.map((e) => {
          let status: ComponentProps<typeof EventInfoCardStatus>['status'] =
            'ongoing';
          if (e.start_date && new Date(e.start_date) > new Date()) {
            status = 'planned';
          }
          if (e.end_date && new Date(e.end_date) < new Date()) {
            status = 'finished';
          }
          return (
            <EventInfoCard key={e.id}>
              <EventInfoCardStatus status={status} />
              <EventInfoCardTitle>{e.name}</EventInfoCardTitle>
              {e.start_date && e.end_date && (
                <EventInfoCardDate
                  startDate={e.start_date}
                  endDate={e.end_date}
                />
              )}
              <Separator className="tw:my-4" />
              <EventInfoCardActions>
                <Button variant="secondary" onClick={() => onEventSelect?.(e)}>
                  View details
                </Button>
              </EventInfoCardActions>
            </EventInfoCard>
          );
        })}
      </div>
    </div>
  );
}
